import React from 'react';
import PropTypes from 'prop-types';

import TableModalComponent from './TableModalComponent';
import { colours, scenarios as scenarioConstants } from './../helpers';
import Moment from 'moment';
import { ControlLabel } from 'react-bootstrap';

const inProgressStates = [
  scenarioConstants.SCENARIO_DISPATCHED,
  scenarioConstants.SCENARIO_RUNNING,
  scenarioConstants.SCENARIO_SETTING_UP,
  scenarioConstants.SCENARIO_SCANNING_CCF,
  scenarioConstants.SCENARIO_SCANNING_NCF
];

const getStatusCell = (status) => {
  let color = {};
  if (status === scenarioConstants.SCENARIO_COMPLETED) {
    color = { color: colours.colours.green };
  } else if (status === scenarioConstants.SCENARIO_ERROR ||
    status === scenarioConstants.SCENARIO_FAILED) {
    color = { color: colours.colours.red };
  }
  return [
    <td key={0}>
      <ControlLabel style={{ ...color }}>
        {status}
      </ControlLabel>
    </td>
  ];
};

const ScenarioModalComponent = ({
  title,
  isVisible,
  scenarios,
  inProgressOnly,
  setInProgressOnly,
  onHide
}) => {

  const headers = [
    'Scenario', 'Dispatched', 'Last Updated', 'Status'
  ];

  const rows = scenarios.reduce((result, scenario, index) => {
    if (
      !inProgressOnly || inProgressStates.some(s => s === scenario.status)
    ) {
      result.push(
        <tr key={index}>
          <td>{scenario.name}</td>
          <td>{Moment(scenario.created_at).format('MMM D YYYY, h:mm:ss a')}</td>
          <td>{Moment(scenario.updated_at).format('MMM D YYYY, h:mm:ss a')}</td>
          {getStatusCell(scenario.status)}
        </tr>
      );
    }
    return result;
  }, []);

  const beforeTable = (
    <div style={{ display: 'block' }} className="pull-right">
      <label>
        Hide Completed Scenarios
        <input
          type="checkbox"
          checked={inProgressOnly}
          style={{ marginLeft: '10px' }}
          onChange={e => setInProgressOnly(e.target.checked)}
        />
      </label>
    </div>
  );

  return (
    <TableModalComponent
      title={title}
      isVisible={isVisible}
      isTableVisible
      onHide={onHide}
      tableHeaders={headers}
      tableRows={rows}
      beforeTableChildren={beforeTable}
    />
  );
};

ScenarioModalComponent.propTypes = {
  title: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  scenarios: PropTypes.arrayOf(PropTypes.object).isRequired,
  inProgressOnly: PropTypes.bool.isRequired,
  setInProgressOnly: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired
};

export default ScenarioModalComponent;


// WEBPACK FOOTER //
// src/Components/ScenarioModalComponent.jsx